import { createFileRoute, redirect } from '@tanstack/react-router'
import { StatusCodes } from 'http-status-codes'

export const Route = createFileRoute('/(redirects)/places')({
  loader: () => {
    throw redirect({ to: '/place/list', statusCode: StatusCodes.MOVED_PERMANENTLY })
  },
})
